/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PageAdminAppointedVisitDto } from '../model';
/**
 * AdminReportsControllerApi - axios parameter creator
 * @export
 */
export const AdminReportsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/reports/names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} dateFrom 
         * @param {any} dateTo 
         * @param {any} [userEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookedVisitsReport: async (dateFrom: any, dateTo: any, userEmail?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateFrom' is not null or undefined
            assertParamExists('getBookedVisitsReport', 'dateFrom', dateFrom)
            // verify required parameter 'dateTo' is not null or undefined
            assertParamExists('getBookedVisitsReport', 'dateTo', dateTo)
            const localVarPath = `/api/admin/reports/booked-visits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEegDetailsReport: async (startDate: any, endDate: any, doctorId?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getEegDetailsReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getEegDetailsReport', 'endDate', endDate)
            const localVarPath = `/api/admin/reports/eeg/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (doctorId !== undefined) {
                localVarQueryParameter['doctorId'] = doctorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEegDoctors: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/reports/eeg/doctors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEegSummaryReport: async (startDate: any, endDate: any, doctorId?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getEegSummaryReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getEegSummaryReport', 'endDate', endDate)
            const localVarPath = `/api/admin/reports/eeg/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (doctorId !== undefined) {
                localVarQueryParameter['doctorId'] = doctorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [appointedBy] 
         * @param {any} [isPaid] 
         * @param {any} [patientFirstName] 
         * @param {any} [patientLastName] 
         * @param {any} [page] Zero-based page index (0..N)
         * @param {any} [size] The size of the page to be returned
         * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisits: async (startDate: any, endDate: any, appointedBy?: any, isPaid?: any, patientFirstName?: any, patientLastName?: any, page?: any, size?: any, sort?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getVisits', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getVisits', 'endDate', endDate)
            const localVarPath = `/api/admin/reports/visits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (appointedBy !== undefined) {
                localVarQueryParameter['appointedBy'] = appointedBy;
            }

            if (isPaid !== undefined) {
                localVarQueryParameter['isPaid'] = isPaid;
            }

            if (patientFirstName !== undefined) {
                localVarQueryParameter['patientFirstName'] = patientFirstName;
            }

            if (patientLastName !== undefined) {
                localVarQueryParameter['patientLastName'] = patientLastName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminReportsControllerApi - functional programming interface
 * @export
 */
export const AdminReportsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminReportsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdmins(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdmins(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} dateFrom 
         * @param {any} dateTo 
         * @param {any} [userEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookedVisitsReport(dateFrom: any, dateTo: any, userEmail?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookedVisitsReport(dateFrom, dateTo, userEmail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEegDetailsReport(startDate: any, endDate: any, doctorId?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEegDetailsReport(startDate, endDate, doctorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEegDoctors(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEegDoctors(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEegSummaryReport(startDate: any, endDate: any, doctorId?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEegSummaryReport(startDate, endDate, doctorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [appointedBy] 
         * @param {any} [isPaid] 
         * @param {any} [patientFirstName] 
         * @param {any} [patientLastName] 
         * @param {any} [page] Zero-based page index (0..N)
         * @param {any} [size] The size of the page to be returned
         * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisits(startDate: any, endDate: any, appointedBy?: any, isPaid?: any, patientFirstName?: any, patientLastName?: any, page?: any, size?: any, sort?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<PageAdminAppointedVisitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisits(startDate, endDate, appointedBy, isPaid, patientFirstName, patientLastName, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminReportsControllerApi - factory interface
 * @export
 */
export const AdminReportsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminReportsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdmins(options?: any): Promise<any> {
            return localVarFp.getAdmins(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} dateFrom 
         * @param {any} dateTo 
         * @param {any} [userEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookedVisitsReport(dateFrom: any, dateTo: any, userEmail?: any, options?: any): Promise<any> {
            return localVarFp.getBookedVisitsReport(dateFrom, dateTo, userEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEegDetailsReport(startDate: any, endDate: any, doctorId?: any, options?: any): Promise<any> {
            return localVarFp.getEegDetailsReport(startDate, endDate, doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEegDoctors(options?: any): Promise<any> {
            return localVarFp.getEegDoctors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [doctorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEegSummaryReport(startDate: any, endDate: any, doctorId?: any, options?: any): Promise<any> {
            return localVarFp.getEegSummaryReport(startDate, endDate, doctorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} startDate 
         * @param {any} endDate 
         * @param {any} [appointedBy] 
         * @param {any} [isPaid] 
         * @param {any} [patientFirstName] 
         * @param {any} [patientLastName] 
         * @param {any} [page] Zero-based page index (0..N)
         * @param {any} [size] The size of the page to be returned
         * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisits(startDate: any, endDate: any, appointedBy?: any, isPaid?: any, patientFirstName?: any, patientLastName?: any, page?: any, size?: any, sort?: any, options?: any): Promise<PageAdminAppointedVisitDto> {
            return localVarFp.getVisits(startDate, endDate, appointedBy, isPaid, patientFirstName, patientLastName, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminReportsControllerApi - object-oriented interface
 * @export
 * @class AdminReportsControllerApi
 * @extends {BaseAPI}
 */
export class AdminReportsControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsControllerApi
     */
    public getAdmins(options?: AxiosRequestConfig) {
        return AdminReportsControllerApiFp(this.configuration).getAdmins(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} dateFrom 
     * @param {any} dateTo 
     * @param {any} [userEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsControllerApi
     */
    public getBookedVisitsReport(dateFrom: any, dateTo: any, userEmail?: any, options?: AxiosRequestConfig) {
        return AdminReportsControllerApiFp(this.configuration).getBookedVisitsReport(dateFrom, dateTo, userEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} startDate 
     * @param {any} endDate 
     * @param {any} [doctorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsControllerApi
     */
    public getEegDetailsReport(startDate: any, endDate: any, doctorId?: any, options?: AxiosRequestConfig) {
        return AdminReportsControllerApiFp(this.configuration).getEegDetailsReport(startDate, endDate, doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsControllerApi
     */
    public getEegDoctors(options?: AxiosRequestConfig) {
        return AdminReportsControllerApiFp(this.configuration).getEegDoctors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} startDate 
     * @param {any} endDate 
     * @param {any} [doctorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsControllerApi
     */
    public getEegSummaryReport(startDate: any, endDate: any, doctorId?: any, options?: AxiosRequestConfig) {
        return AdminReportsControllerApiFp(this.configuration).getEegSummaryReport(startDate, endDate, doctorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} startDate 
     * @param {any} endDate 
     * @param {any} [appointedBy] 
     * @param {any} [isPaid] 
     * @param {any} [patientFirstName] 
     * @param {any} [patientLastName] 
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsControllerApi
     */
    public getVisits(startDate: any, endDate: any, appointedBy?: any, isPaid?: any, patientFirstName?: any, patientLastName?: any, page?: any, size?: any, sort?: any, options?: AxiosRequestConfig) {
        return AdminReportsControllerApiFp(this.configuration).getVisits(startDate, endDate, appointedBy, isPaid, patientFirstName, patientLastName, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}

